import { filter } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableFilter'
})
export class TableFilterPipe implements PipeTransform {

  transform(items: any, args: any): any {
    const keys = Object.keys(args).filter((key) => args[key] !== undefined);

    if (keys.length > 0) {
      return items.filter((item: any) => {
        return keys.some((key) => {
          if (item[key] != null) {
            return item[key].toLocaleLowerCase().includes(args[key].toLocaleLowerCase());
          }
        });
      });
    } else {
      return items;
    }
  }
}
